export function swipersInit() {

  const swiperBanners = new Swiper('.swiper-banners', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    speed: 700,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination.banners',
      clickable: true,
    },
  });

  const swiperNewModels = new Swiper('.swiper-new-model', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    slidesPerView: 1,
    spaceBetween: 10,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '.swiper-button-next.new-model',
      prevEl: '.swiper-button-prev.new-model',
    },
    pagination: {
      el: '.swiper-pagination.new-model',
      dynamicBullets: true,
      clickable: true,
    },
    breakpoints:{
      992: {
        slidesPerView: 4,
        spaceBetween: 5,
      }
    }
  });

  const swiperUsedModelInternalStamp = new Swiper('.used-model-internal-stamps-slider', {
    clickable: true,
    slidesPerView: 3,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination.stamp',
      clickable: true
    },
  });

  const swiperUsedModelInternalThumbs = new Swiper('.used-model-internal-slider-thumbs', {
    slidesPerView: 3,
    freeMode: true,
    spaceBetween: 60,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper-button-next.used-thumbs',
      prevEl: '.swiper-button-prev.used-thumbs',
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 0,
      }
    }
  });

  const usedModelInternalSwiper = new Swiper('.used-model-internal-slider-content', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.used',
      prevEl: '.swiper-button-prev.used',
    },
    clickable: true,
    thumbs: {
      swiper: swiperUsedModelInternalThumbs,
    },
  });


$("[data-fancybox='galeria-de-usados-2']").fancybox({
    afterClose: function(instance, slide) {
      let currentIndex = instance.currIndex; // Obtém o índice da imagem ativa no Fancybox
      // Atualiza manualmente o Swiper principal para a imagem correspondente
      usedModelInternalSwiper.slideTo(currentIndex);
      usedModelInternalSwiper.slidesUpdated();
  
      // Atualiza a opacidade da miniatura correspondente
      setTimeout(() => {
        document.querySelectorAll('.used-model-internal-slider-thumbs .swiper-slide').forEach((thumb, index) => {
        swiperUsedModelInternalThumbs.slideTo(currentIndex); 
  
        $(".used-model-internal-slider-thumbs .swiper-slide").each(function (index) {
          if (index === currentIndex) {
            thumb.classList.add("swiper-slide-thumb-active");
            $(this).addClass("swiper-slide-thumb-active");
          } else {
            thumb.classList.remove("swiper-slide-thumb-active");
            $(this).removeClass("swiper-slide-thumb-active");
          }
        });
      }, 50);
      }, 100); // Pequeno delay para garantir a atualização correta
    }
  });

  
  

  const swiperUsedModelInternalRelated = new Swiper('.used-model-internal-related-slider', {
    clickable: true,
    slidesPerView: 1,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    pagination: {
      el: '.swiper-pagination.related',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next.related',
      prevEl: '.swiper-button-prev.related',
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 15,
      }
    }
  });
}
